{
  "navigation_tabbar": {
    "home": "Home",
    "create": "Boeken",
    "coworkers": "Collega's",
    "more": "Meer"
  },
  "titles": {
    "today": "Home",
    "presence_scan": "Aanwezigheid scannen",
    "presence_transport": "Transport keuze",
    "book_license_plate": "Kenteken voertuig",
    "add_booking_lunch": "Lunchkeuze",
    "add_booking_license_plate": "Kenteken voertuig",
    "add_booking_date": "Tijdsloten",
    "add_booking_overview": "Boekingen controleren",
    "add_booking_success": "Boekingen geplaatst",
    "more_inbox_view": "Inbox",
    "invitation_received": "Ontvangen uitnodigingen",
    "invitation_sent": "Verzonden uitnodigingen",
    "more_settings": "Instellingen",
    "more_privacy": "Privacy",
    "more_profile": "Mijn profiel",
    "more_management": "Beheer",
    "more_inbox": "Inbox",
    "more_workdays": "Mijn werkdagen",
    "more_about_my_office_days": "Over $t(app_name)",
    "more_calendar_subscription": "Koppel boekingen aan kalender",
    "more_accounts": "Accounts",
    "more_index": "Meer",
    "add_booking_option": "Boeken",
    "coworkers": "Collega's",
    "more_travel_history": "Mijn reisgeschiedenis",
    "events": "Evenementen",
    "event_view": "Evenement",
    "more_lunch_scanner": "Lunch scanner",
    "add_booking_location": "Locatie",
    "add_booking_view_coworker": "Gekozen collega's",
    "add_booking_select_coworker": "Selecteer collega's",
    "coworkers_view": "Collega",
    "coworkers_filter_selection": "Filter",
    "coworkers_filter_results": "Filter resultaten",
    "qrcode_scan": "QR-code scannen",
    "credits": "Credits",
    "credits_buy": "Credits kopen"
  },
  "tabs": {
    "more_settings_privacy": "Privacy",
    "more_settings_settings": "App",
    "more_settings_cache": "Cache",
    "more_travel_history_history": "Geschiedenis",
    "more_travel_history_profiles": "Profielen"
  },
  "buttons": {
    "cache_clear": "Cache legen",
    "save": "Opslaan",
    "logout": "Uitloggen",
    "cancel": "Annuleren",
    "ok": "Ok",
    "change_to_app": "Naar app",
    "book": "Boeken",
    "view": "Bekijken",
    "buy": "Kopen"
  },
  "loading": {
    "capacity": "Berekenen capaciteit",
    "team_members": "Bezig met ophalen teamleden",
    "search_results": "Bezig met zoeken",
    "external_contacts": "Bezig met het ophalen van jouw contacten",
    "messages": "Bezig met ophalen van berichten",
    "timeslot_groups": "Bezig met ophalen van tijdslot groepen",
    "timeslot_kinds": "Bezig met ophalen van tijdslot soorten"
  },
  "saving": {
    "booking": "We plaatsen je boeking(en)"
  },
  "hints": {
    "title": "$t(app_name) tip",
    "booking_invite_click_employee_to_accept": "Je kan op de persoon klikken om deze op voorhand te accepteren."
  },
  "text": {
    "unread_messages": "Je hebt {{amount}} ongelezen berichten"
  },
  "enums": {
    "employee_status": {
      "unknown": "Onbekend",
      "in_meeting": "In bespreking",
      "having_lunch": "Having lunch",
      "present": "Aanwezig",
      "not_yet_present": "Nog niet aanwezig",
      "left": "Niet meer aanwezig",
      "work_from_home": "Werkt vanuit huis",
      "work_from_home_2": "Werkt vanuit huis"
    },
    "read_more": "Lees meer",
    "license": {
      "license_plate": {
        "title": "Kenteken"
      },
      "car_fuel_type": {
        "title": "Benzine type"
      },
      "car_length": {
        "title": "Lengte"
      },
      "car_width": {
        "title": "Breedte"
      },
      "car_height": {
        "title": "Hoogte"
      },
      "car_weight": {
        "title": "Gewicht"
      }
    }
  },
  "pages": {
    "authentication": {
      "qr-code": {
        "title": "Via App",
        "explanation-1": "Open de $t(app_name) app.",
        "explanation-2": "Druk op het homescherm op de QR-code knop rechts boven.",
        "explanation-3": "Scan de qr-code om direct in te loggen!"
      },
      "token": {
        "title": "Via Token (SMS/E-mail)"
      },
      "testflight": {
        "title": "$t(app_name) Beta",
        "description": "Bedankt voor je deelname aan de $t(app_name) Beta test!\n\nWij hopen dat alles werkt zoals verwacht maar als je tegen een fout aanloopt laat het ons gerust weten.\n\n\nLukt het je niet om boekingen te plaatsen of loop je tegen andere grote problemen aan? Via de Apple App-store of Google Play-store kan je de huidige stabiele versie opnieuw installeren",
        "ok": "Ok"
      }
    },
    "loading": {
      "slow_connection": "Het laden lijkt langer te duren dan normaal\ncontroleer je internet verbinding"
    },
    "home": {
      "favourite_presence": {
        "title": "Favoriete collega's",
        "no_bookings_favourites": "Er zijn nog geen boekingen geplaatst op {{date}} door jouw favorieten"
      },
      "update": {
        "available": "Er is een update beschikbaar voor $t(app_name)! We raden je aan de update te installeren wat slechts enkele seconden duurt.",
        "update_now": "Update nu",
        "hide": "Verberg"
      },
      "build": {
        "available": "Er is een update beschikbaar voor $t(app_name) in de store! We raden je aan de update te installeren wat slechts enkele seconden duurt.",
        "goto_app_store": "Naar store",
        "hide": "Verberg"
      }
    },
    "book": {
      "license_plate": {
        "multi_option": "Wijzig met onderstaande invoerveld direct het kenteken in één keer.",
        "explanation": "Om toegang te krijgen tot je parkeerplaats dient het kenteken van je voertuig bekend te zijn",
        "default_not_set": "Kom je altijd met dezelfde auto naar kantoor? Stel je kenteken in bij je profiel en we vullen deze standaard voor je in, dat scheelt je een hoop kostbare tijd!",
        "invalid": "Het ingevulde kenteken kan niet worden gevonden",
        "limitation_error": "Dit voertuig voldoet niet aan de vereiste beperkingen.",
        "modal": {
          "title": "Informatie",
          "text": "Je voertuig voldoet niet aan de vereiste beperkingen. Hieronder staan de foutmeldingen aangegeven:"
        },
        "errors": {
          "car_fuel_type": "Voldoet niet aan de vereiste brandstoftype",
          "car_length": "Voldoet niet aan de maximale lengte",
          "car_width": "Voldoet niet aan de maximale breedte",
          "car_height": "Voldoet niet aan de maximaal hoogte",
          "car_wheelbase": "Voldoet niet aan de maximale wielbasis",
          "car_weight": "Voldoet niet aan het maximale gewicht",
          "current": "Huidig: {{value}}",
          "allowed": "Toegestaan: {{value}}"
        },
        "is_same": "De ingevulde kentekens voor dit tijdslot zijn hetzelfde. Dit is niet toegestaan.",
        "car_dimensions_missing": "We kunnen dit kenteken niet volledig controleren omdat de gegevens niet beschikbaar zijn bij het RDW. Na de boeking wordt deze handmatig gecontroleerd."
      }
    },
    "more": {
      "sections": {
        "account": "Account",
        "preferences": "Voorkeuren en koppelingen",
        "session": "Accounttoegang"
      },
      "settings": {
        "cache": {
          "explanation": "Door informatie op te slaan die niet vaak wordt gewijzigd op jouw telefoon zorgt caching ervoor dat $t(app_name) veel soepeler aanvoelt. Heb je het idee dat informatie toch niet up-to-date is? Leeg dan de cache voor het ophalen van de nieuwste informatie."
        }
      },
      "about": {
        "explanation": ".",
        "block_1": "Hartelijk dank voor het gebruik van $t(app_name). We hopen dat je een van de duizenden tevreden gebruikers van $t(app_name) bent. Wil je vrienden en familie laten weten hoe gemakkelijk het kan zijn om ook een paar 'kantoordagen' te hebben? Je zou ons helpen door het woord over $t(app_name) te verspreiden.",
        "block_2": "Onze geschiedenis: My office day is onderdeel van het internationale bedrijf On-d-mand. On-d-mand is opgericht in 2005 en gevestigd in Diemen, Nederland. Het bedrijf is gespecialiseerd in het ontwikkelen van (web)applicaties, voornamelijk voor multinationals. On-d-mand diensten worden gebruikt in meer dan 15 landen.",
        "block_3": "De $t(app_name) app heeft veel overeenkomsten met onze andere diensten, zoals de Hospitality manager software, die al meer dan 10 jaar wordt gebruikt door bedrijven als Ziggo, Aegon, Funda, Coca cola en Heineken. Zij gebruiken de Hospitality manager software om het uitnodigings- en registratieproces vast te leggen voor de evenementen die zij sponsoren.",
        "share": "Deel onze website",
        "view": "Bezoek onze website"
      },
      "profile": {
        "resolve_error": "De volgende informatie ontbreekt momenteel nog, vul deze aan en sla je profiel op om $t(app_name) weer te gebruiken",
        "errors": {
          "no_team": "Je hebt nog geen team geselecteerd",
          "address": "De postcode kon niet worden gevonden",
          "no_address": "Je hebt nog geen postcode ingevuld",
          "no_license_plate": "Je hebt nog geen kenteken ingevuld",
          "no_transport_kind": "Je hebt nog geen vervoerskeuze geselecteerd"
        },
        "no_preference": "Geen standaard voorkeur"
      },
      "accounts": {
        "saved_accounts": "Opgeslagen accounts",
        "save_error_title": "Account kon niet worden opgeslagen",
        "save_error": "Je account kon niet op dit apparaat worden opgeslagen. Probeer het opnieuw.",
        "add_account": "Account toevoegen",
        "active_account": "Actief account",
        "other_accounts": "Andere accounts",
        "will_logout": "Bij het toevoegen van een account wordt je automatisch uitgelogged. Log vervolgens in op het nieuwe account om deze toe te voegen.",
        "enable_multi_account": "Multi account inschakelen",
        "remove_all_accounts": "Verwijder alle andere accounts"
      }
    },
    "coworker_favourites": {
      "no_favourites": "Je favorieten lijst is nog leeg, zoek collega's en klik op het hartje naast hun naam om ze toe te voegen"
    },
    "coworker_eros": {
      "no_eros": "Er lijken momenteel geen bedrijfshulpverleners op kantoor te zijn!"
    },
    "coworker_confidants": {
      "description": "Wil je een luisterend oor, advies of hulp bij ongewenst gedrag? Neem contact op met een vertrouwenspersoon.\n\nWe zijn er voor je!",
      "no_confidants": "Er lijken momenteel geen vertrouwenspersonen bekend."
    }
  },
  "alerts": {
    "are_you_sure": {
      "title": "Weet je het zeker?"
    },
    "are_you_sure_multi_account": {
      "title": "Weet je het zeker?",
      "message": "Je hebt meerdere accounts gekoppeld aan dit toestel, als je uitlogged zullen alle accounts ontkoppeld worden van dit toestel"
    }
  },
  "constants": {
    "ero": "BHV",
    "confidant": "Vertrouwens-persoon",
    "location": "Locatie",
    "workplaces_count": "Werkplekken beschikbaar",
    "lunches_count": "Lunchplekken beschikbaar",
    "meetingroom_count": "Zitplaatsen beschikbaar",
    "transport_count": "Parkeerplaatsen beschikbaar",
    "coworkers_booked": "Collega's",
    "information": "Informatie",
    "status": "Status",
    "lunch_option": "Lunchkeuze",
    "license_plate": "Kenteken",
    "capacity_remaining": {
      "booking": "{{capacity_remaining}}"
    },
    "not_available": {
      "booking": "Niet beschikbaar"
    },
    "no_capacity_remaining": {
      "booking": "Niet beschikbaar"
    },
    "insufficient_capacity_remaining": {
      "booking": "Onvoldoende ({{capacity_remaining}} van de {{required_amount}})"
    },
    "timeslots": {
      "booking": "Werkplekken",
      "lunch": "Lunches",
      "transport": "Parkeerplaatsen",
      "meeting_room": "Meeting rooms",
      "custom": "Aangepast"
    },
    "edit": "Bewerken",
    "scan_status": "Scan status",
    "parking_scan_status": "Parkeer scan status",
    "not_in_office": "Niet op kantoor",
    "date": "Datum",
    "time": "Tijd",
    "coworker": "Collega",
    "credit": "Credit kosten"
  },
  "page": {
    "home": {
      "greeting": "Hi {{name}},",
      "in_the_office": "Ben je op kantoor aangekomen?",
      "welcome_in_the_office": "Welkom op kantoor, fijne werkdag!",
      "left_the_office": "Vertrokken?"
    },
    "notifications": {
      "app_update_required": {
        "title": "Versie update vereist",
        "description": "Je draait momenteel geen up-to-date versie van onze app, om verder te gaan dient de nieuwste versie geinstalleerd te zijn. Via de onderstaande knop kan je naar de {{store}} gaan om deze direct te downloaden"
      },
      "maintenance": {
        "title": "Onderhoud",
        "description": "We zijn momenteel druk bezig met onderhoud aan jullie omgeving, het is daarom niet mogelijk om boekingen te maken of bekijken.\n\nDit scherm verdwijnt vanzelf zodra wij klaar zijn.",
        "countdown": "Controleren van de voortgang in {{seconds}} seconden"
      },
      "ota_update_required": {
        "title": "Versie update vereist",
        "description": "Je draait momenteel geen up-to-date versie van onze app, om verder te gaan dient de nieuwste versie geinstalleerd te zijn. Door op de onderstaande knop te drukken zal de nieuwste versie van de app worden opgehaald."
      },
      "ignore": "Negeren",
      "open_store": "Open {{store}}"
    },
    "create": {
      "overview": {
        "save": {
          "alert_title": "Mislukt",
          "alert_message": "Bij het opslaan van de boekingen is er een onbekende fout opgetreden, probeer het opnieuw."
        },
        "intro_other": "Controleer de gekozen tijdsloten",
        "intro": "Controleer het gekozen tijdslot",
        "no_timeslots": "Er zijn geen tijdsloten gekozen",
        "booking_save": "Boeking plaatsen",
        "title": "Controleren",
        "invitation_save": "Boeking confirmeren",
        "invitation_save_other": "Boekingen confirmeren",
        "booking_save_other": "Boekingen plaatsen",
        "form": {
          "reason": {
            "title": "Reden van boeking"
          },
          "description": {
            "title": "Beschrijving"
          },
          "name": {
            "title": "Titel"
          },
          "show_invitees": {
            "title": "Toon de genodigden in de uitnodiging die wordt verstuurd"
          }
        },
        "users": {
          "title": "Genodigden"
        },
        "bookings": {
          "title": "Boekingen"
        },
        "captcha_modal": {
          "title": "Plaatsen van boeking mislukt",
          "text": "Het is helaas niet gelukt om de boeking te plaatsen. We raden aan om het opnieuw te proberen. Als het probleem aanhoudt, neem dan contact op met onze klantenservice voor verdere assistentie."
        }
      },
      "lunch": {
        "intro": "Wijzig met onderstaande keuzelijst direct de lunch opties in één keer.",
        "title": "Lunch opties",
        "profile_default_not_set": "Heb je een lunchvoorkeur? Je kan een standaard lunchkeuze invoeren in je profiel, dat scheelt je een hoop kostbare tijd!",
        "profile_default": "Jouw keuze volgens je profiel",
        "option_only_myself": "De lunchoptie is alleen van toepassing op jouw boeking."
      },
      "date": {
        "no_timeslot_other": "Er zijn geen tijdsloten beschikbaar",
        "no_timeslot": "Er is geen tijdslot beschikbaar",
        "disabled_overlap": "Je hebt al een boeking geplaatst op dit tijdslot",
        "warning": {
          "cart": {
            "title": "Let op",
            "body": "Dit gekozen tijdslot overlapt met een ander eerder tijdslot. Wil je het nieuw gekozen tijdslot vervangen met het eerder gekozen tijdslot?",
            "button_ok": "Doorgaan",
            "button_cancel": "Annuleren"
          }
        },
        "title": "Selecteer tijdsloten",
        "title_selected": "{{number}} tijdslot geselecteerd",
        "title_selected_other": "{{number}} tijdsloten geselecteerd",
        "disabled_not_enough_available": "Niet genoeg plaatsen beschikbaar ({{count}} nodig)",
        "disabled_already_booked": "Dit tijdslot is al geboekt",
        "disabled_not_inviter": "Je hebt dit tijdslot al geboekt en alleen de organisator kan extra collega's toevoegen",
        "disabled_not_available": "Niet beschikbaar",
        "disabled_already_booked_single": "Je hebt dit tijdslot al geboekt",
        "disabled_already_booked_single_timeslot_group": "Je kan per dag slechts 1 boeking plaatsen",
        "disabled_before_from": "Je kan dit tijdslot vanaf {{amount}} {{unit}} van tevoren boeken",
        "disabled_before_from_time": "Je kan dit tijdslot vanaf {{amount}} {{unit}} van tevoren boeken vanaf {{time}} uur",
        "disabled_before_from_time_today": "Je kan dit tijdslot boeken vanaf {{time}} uur",
        "disabled_deadline_passed": "Je kan dit tijdslot tot {{amount}} {{unit}} van tevoren boeken",
        "disabled_deadline_passed_time": "Je kan dit tijdslot tot {{amount}} {{unit}} van tevoren boeken tot {{time}} uur",
        "disabled_deadline_passed_time_today": "Je kon dit tijdslot boeken tot {{time}} uur",
        "validate_timeslots": "Controleer boekingen",
        "select_license_plate": "Kenteken invoeren",
        "select_lunch": "Lunch opties",
        "information_invitation_exists": "Dit tijdslot zit al in een gemaakte uitnodiging. Extra personen zullen worden toegevoegd aan de bestaande uitnodiging.",
        "disabled_block": "Dit tijdslot is niet beschikbaar",
        "disabled_already_booked_single_timeslot_kind": "Je kan per dag slechts 1 {{kind}} boeking plaatsen",
        "disabled_already_booked_single_timeslot_kind_current": "(Huidige boeking: {{current}})"
      },
      "index": {
        "title": "Boeking plaatsen",
        "item_empty": "Selecteer tijdslot"
      },
      "success": {
        "message": "Je wordt automatisch binnen {{seconds}} seconden teruggestuurd.",
        "button": "Ga terug",
        "message_invited": "Voor de extra opgegeven personen hebben we een uitnodiging gestuurd. Nadat je gast(en) de uitnodiging heeft geaccepteerd of afgewezen ontvang je in de app een melding. "
      },
      "transport": {
        "intro": "Wijzig met onderstaande keuzelijst alle gekozen vervoersopties in één keer. Het is natuurlijk ook mogelijk om per dag los een vervoersoptie te selecteren.",
        "title": "Vervoersopties"
      },
      "option": {
        "options": {
          "myself": "Voor mezelf",
          "myself_and_coworkers": "Voor mezelf en collega's",
          "coworkers": "Voor collega's",
          "coworkers_and_externals": "Voor collega's en externen",
          "myself_and_coworkers_and_externals": "Voor mezelf, collega's en externen",
          "myself_and_externals": "Voor mezelf en externen",
          "externals": "Externen"
        },
        "kinds": {
          "meeting_room": {
            "title": "Vergaderruimte"
          },
          "room": {
            "title": "Werkplek, lunch en parkeerplek",
            "title_no_parking_no_lunch": "Werkplek",
            "title_no_parking": "Werkplek en lunch",
            "title_no_lunch": "Werkplek en parkeerplek"
          }
        }
      },
      "from_coworker": {
        "description": "Je hebt net als {{name}} gekozen op '{{date, lowercase}}' aanwezig te zijn op kantoor. Selecteer minimaal één van onderstaande optie(s).",
        "no_booking": "Er is door {{name}} geen boeking gemaakt voor deze dag."
      },
      "coworker": {
        "subtitle": "{{amount}} collega",
        "subtitle_other": "{{amount}} collega's",
        "mode_favourites": "Favorieten",
        "mode_co_workers": "Collega's",
        "mode_external": "Externe relaties",
        "empty": "Geen personen gevonden",
        "check_coworkers": "Controleer collega's",
        "create_booking": "Start met boeken",
        "external": {
          "button_add": "Handmatig gast toevoegen",
          "button_add_from_phone": "Koppelen aan telefoonboek",
          "not_stored_on_server": "Je contactlijst slaan we niet op",
          "not_stored_on_server_click": "klik voor meer informatie",
          "not_stored_on_server_popup": "De contactlijst op jouw telefoon wordt automatisch ingeladen maar zal niet worden opgeslagen in de applicatie OF op onze servers!\n\nWanneer je een boeking maakt zal de naam en het e-mailadres van de gekozen contacten worden opgenomen in $t(app_name) voor de boeking en wordt automatisch verwijderd na een door je werkgevers opgegeven bewaartermijn (meestal na 30 dagen na de boeking)",
          "description": "Nodig je gasten uit door hun gegevens in te vullen. Ze ontvangen een e-mail en kunnen bevestigen of afwijzen, zonder de $t(app_name) app te hoeven installeren.",
          "only_email": "Let op, alleen contacten met een e-mailadres worden hieronder getoond",
          "search": {
            "input_search": "Zoek in contactenlijst"
          }
        },
        "alerts": {
          "changing_coworker": "Het wijzigingen van genodigden zal je gekozen tijdsloten verwijderen, weet je het zeker?"
        },
        "search": {
          "input_search": "Zoeken binnen het hele bedrijf",
          "button_toggle_selected": "Alleen geselecteerd tonen"
        }
      },
      "alert_booking_occupied": {
        "title": "Tijdslot is al geboekt",
        "description": "Je gekozen tijdslot op {{date}} is net geboekt door je collega. We hebben het tijdslot automatisch uit je geselecteerde tijdsloten gehaald."
      }
    },
    "start": {
      "title": "Vandaag",
      "greeting": {
        "morning": "Goedemorgen, {{name}}",
        "afternoon": "Goedemiddag, {{name}}",
        "evening": "Goedenavond, {{name}}",
        "night": "Goedenacht, {{name}}"
      },
      "no_booking_today": "Er zijn voor vandaag geen boekingen gemaakt",
      "your_day": "Zo ziet jouw dag eruit",
      "button_scan_in": "Check nu in",
      "button_scan_out": "Check nu uit",
      "button_mode_of_transport": "Vervoersmiddel",
      "button_mode_of_transport_check_in_first": "Check eerst in",
      "scan_explanation": "Gebruik de onderstaande knop om je in te scannen voor vandaag",
      "scan_status": "Status",
      "scan_statuses": {
        "is_not_scanned_in": "Niet ingecheckt",
        "is_scanned_in": "Ingecheckt",
        "is_scanned_out": "Uitgecheckt"
      },
      "capacity_status": {
        "no_one": "Er is nog niemand aanwezig",
        "not_busy": "Het is niet druk",
        "moderately_busy": "Het is gezellig druk",
        "very_busy": "Het is erg druk"
      },
      "prognosis_status": {
        "no_one": "Verwachting: geen boekingen",
        "not_busy": "Verwachting: het wordt niet druk",
        "moderately_busy": "Verwachting: het wordt gezellig druk",
        "very_busy": "Verwachting: het wordt erg druk"
      },
      "profile": {}
    },
    "booking": {
      "no_booking_found_date": "Je hebt op {{date}} nog geen boekingen.",
      "no_booking_found_date_coworker": "{{name}} heeft op {{date}} nog geen boekingen.",
      "calendar": {
        "title": "Gemaakte boekingen",
        "add_calendar": "Voeg toe aan mijn agenda",
        "calendar": {
          "title": "Kalender"
        },
        "invitations": {
          "title": "Uitnodigingen",
          "item": {
            "title": "Uitnodiging op {{date}}",
            "subtitle": "Gemaakt door {{name}} op {{date}}",
            "name": "Uitnodiging"
          },
          "empty": "Geen uitnodigingen gevonden",
          "received": "Ontvangen uitnodiging",
          "sent": "Verstuurde uitnodiging"
        }
      },
      "invite": {
        "title": "Uitnodiging",
        "description": "Je bent uitgenodigd door {{name}}.",
        "not_found": "We hebben de uitnodiging niet meer kunnen vinden. Dit kan komen doordat de uitnodiging is ingetrokken of omdat de uitnodiging is verlopen.",
        "description_select": "Hieronder staan de tijdslot(en) waarop je bent uitgenodigd, kies de tijdslot(en) die je wilt accepteren en druk onderaan op opslaan.",
        "respond": "Je hebt al op deze uitnodiging gereageerd. Het is niet mogelijk hier aanpassingen in te doen."
      },
      "status": {
        "invited": "Uitgenodigd",
        "invite_accepted": "Geaccepteerd",
        "invite_rejected": "Afgewezen",
        "cancelled": "Geannuleerd",
        "active": "Actief"
      },
      "status_manual_validation": "Deze boeking is nog niet definitief en wordt nog gevalideerd."
    },
    "booking_subscription": {
      "title": "Kalender abonnement",
      "explanation": "Je kunt je boekingen automatisch laten toevoegen aan de agenda op je telefoon. Je agenda wordt dan automatisch bijgewerkt met nieuwe boekingen.",
      "button": "Voeg abonnement toe aan mijn {{name}} agenda",
      "button_copy": "Kopieer kalender link"
    },
    "scan": {
      "title": "Scannen",
      "scanned": {
        "error": "Het is niet gelukt de scan op te slaan, probeer het opnieuw.",
        "error_title": "Mislukt",
        "error_no_booking": "Je hebt vandaag geen boekingen, inchecken is daarom niet mogelijk",
        "error_title_no_booking": "Mislukt",
        "error_insufficient_access": "Je hebt onvoldoende rechten om deze locatie te boeken",
        "error_insufficient_access_title": "Mislukt",
        "error_no_booking_title": "Mislukt",
        "error_no_rights_to_scan_presence_qr_code_title": "Onvoldoende rechten",
        "error_no_rights_to_scan_presence_qr_code": "Je hebt onvoldoende rechten om dit type QR-code te scannen en de aanwezigheid vast te leggen"
      },
      "scan_in": "Inchecken",
      "scan_out": "Uitchecken",
      "scan_success": "Het scannen van de QR-code is gelukt, je bent nu ingecheckt!"
    },
    "validate_booking": {
      "title": "Check-in medewerker",
      "errors": {
        "code_expired": "Qr-code is verlopen, scan opnieuw",
        "code_invalid": "Qr-code of boeking is niet geldig",
        "scanned_in": "Medewerker is reeds ingescanned"
      },
      "buttons": {
        "checkin": "Check-in",
        "cancel": "Andere een QR-code scannen"
      }
    },
    "coworker": {
      "title": "Collega's",
      "title_singular": "Collega",
      "add": "Toevoegen",
      "no_following": "Je hebt momenteel geen collega's als favoriet",
      "no_followers": "Je hebt momenteel geen collega's die jou als favoriet hebben",
      "cancel_search": "Annuleren",
      "following": "Favoriet",
      "followers": "Favorieten",
      "calendar": {
        "button_book_also": "Ook deze boekingen boeken voor {{date, lowercase}}"
      },
      "followed": "Heeft jou als favoriet",
      "following_not": "Maak favoriet",
      "followed_not": "Maak favoriet van jou",
      "favourites": "Favorieten",
      "search": "Zoeken",
      "alert": {
        "unfollow_coworker": {
          "title": "Weet je het zeker?",
          "description": "Weet je het zeker dat je {{name}} niet als favoriet wilt hebben?"
        },
        "unfollow_non_coworker": {
          "title": "Weet je het zeker?",
          "description": "Weet je het zeker dat je {{name}} niet als favoriet wilt hebben? Je kan hem/haar alleen nog volgen na het ontvangen van een uitnodiging."
        },
        "unfollowed_coworker": {
          "title": "Weet je het zeker?",
          "description": "Weet je het zeker dat {{name}} jou niet meer als favoriet wilt hebben?"
        },
        "unfollowed_non_coworker": {
          "title": "Weet je het zeker?",
          "description": "Weet je het zeker dat {{name}} jou niet meer als favoriet wilt hebben? Hij/zij kan je alleen opnieuw volgen na het ontvangen van een uitnodiging."
        },
        "ok": "Ok",
        "cancel": "Cancel"
      },
      "dotmenu": {
        "add_coworkers": "Collega's toevoegen",
        "my_qr_code": "Deel mijn boekingen met collega's"
      },
      "eros": "BHV'ers",
      "confidants": "Vertrouwenspersonen",
      "no_ero": "Er zijn geen BHV'ers aangemeld voor vandaag",
      "search_list": {
        "team": "Resultaat binnen het team",
        "organization": "Resultaat binnen het bedrijf"
      },
      "filters": {
        "title": "Filter",
        "searching": "Bezig met zoeken",
        "no_filters": "Selecteer de gewenste filters om te zoeken",
        "no_filters_short": "Geen filters",
        "no_results": "Geen resultaten gevonden op basis van de ingestelde filters",
        "view_results": "Toon {{amount}} resultaten",
        "filters": "Filters",
        "apply": "Pas toe",
        "reset": "Reset filters",
        "change": "Wijzig filter",
        "remove_selection": "Verwijder selectie",
        "close": "Sluiten",
        "filter_names": {
          "name": "Naam",
          "company_guid": "Bedrijf",
          "department_guid": "Afdeling",
          "team_guid": "Team",
          "jobtitle_guid": "Functie"
        },
        "too_many_results": "{{amount}}+ resultaten, verfijn filters"
      },
      "filter": {
        "no_filters": "Geen filters ingesteld",
        "title": "Filter"
      }
    },
    "search": {
      "title": "Voeg collega's toe",
      "follow_added": "Je volgt nu {{name}}",
      "no_result": "Er zijn geen collega's gevonden",
      "department_mode": "Jouw team",
      "scan_mode": "Scan QR-code",
      "result_for": "Resultaat voor \"{{query}}\""
    },
    "share": {
      "title": "QR-code",
      "my_code": "Mijn qr-code",
      "scan_code": "Scan een qr-code",
      "explanation": "Door de QR-code te scannen door een collega of het delen van je uitnodigingslink krijgt hij/zij inzicht in jouw boekingen.",
      "share_link": "Volg mijn boekingen in $t(app_name) door op de volgende link te klikken {{- url}}",
      "error": "Het maken van de uitnodigingslink is niet gelukt",
      "button_try_again": "Probeer opnieuw",
      "button_share": "Deel mijn uitnodigingslink"
    },
    "information": {
      "buttonbar": {
        "messages": "Berichten",
        "covid": "Corona richtlijnen"
      },
      "title": "Informatie",
      "source": "Bron: RIVM",
      "block": {
        "wash_hands": "Was regelmatig je handen",
        "dont_shake_hands": "Schud geen handen",
        "distance": "Houd 1,5 meter afstand",
        "cough": "Hoest in je elleboog",
        "stay_home": "Heb je klachten? Meld dit bij je leidinggevende en blijf thuis!",
        "title": "Alleen samen krijgen we corona onder controle"
      },
      "no_messages": "Er zijn nog geen berichten geplaatst"
    },
    "profile": {
      "title": "Profiel",
      "save": "Opslaan",
      "saved": "Profile is opgeslagen",
      "logout": "Uitloggen",
      "profile": {
        "ad_sync_enabled": "Jouw persoonlijke informatie wordt beheerd door je werkgever",
        "no_roll_permission": "Om een foto te uploaden heeft deze app toegang nodig tot je foto's",
        "title": "Profiel"
      },
      "settings": {
        "title": "Instellingen",
        "no_settings": "Er zijn geen instellingen beschikbaar",
        "clear_cache": "Legen"
      },
      "ero": {
        "title": "BHV'er",
        "introduction": "Mocht je een bedrijfshulpverlener (BHV'er) zijn dan kan je dat op deze pagina aangeven. Als BHV'er kunnen collega's jou direct bellen bij een noodgeval als jij op kantoor aanwezig bent.",
        "is_ero": "{{name}} is bedrijfshulperlener"
      }
    },
    "message": {
      "title": "Berichten",
      "empty": "Er zijn nog geen berichten.",
      "action": {
        "read_all": "Markeer alles als gelezen",
        "archive_all": "Archiveer alle berichten"
      }
    },
    "message_view": {
      "title": "Bericht",
      "attachment": {
        "button_view_employee_booking_invitation": "Bekijk uitnodiging",
        "button_view_employee_booking_INVITATION_SENT": "Bekijk overzicht"
      },
      "action": {
        "archive": "Archiveer bericht"
      }
    },
    "authentication": {
      "domain": {
        "alerts": {
          "account_locked": {
            "message": "Je account is geblokeerd vanwege herhaaldelijke foute invoer van de beveiligingstoken. Probeer het over 15 minuten nogmaals.",
            "title": "Account geblokeerd"
          },
          "something_went_wrong": {
            "message": "Er lijkt iets misgegaan te zijn, probeer het nogmaals",
            "title": "Er ging iets fout"
          },
          "user_not_found": {
            "message": "Het opgegeven e-mailadres kan niet worden gevonden, neem contact op met jouw beheerder",
            "title": "E-mail niet gevonden"
          },
          "no_management_access": {
            "title": "Geen toegang tot het beheer",
            "message": "Jouw account heeft geen toegang tot het beheer, neem contact op met het $t(app_name) team voor meer informatie."
          },
          "invalid_token": {
            "message": "De ingevoerde token is onjuist, probeer het nogmaals",
            "title": "Token onjuist"
          },
          "token_resend": {
            "message": "Er is een nieuwe token verzonden per e-mail, voer altijd de laatst ontvangen token in.",
            "title": "Token opnieuw verzonden"
          }
        },
        "button": "Verstuur log-in token",
        "button_loading": "Bezig met versturen",
        "domain": "Domein",
        "domain_hint": "Voer het domein van je organisatie in",
        "domain_placeholder": "organisatie",
        "domain_checking": "Domein controleren…",
        "email": "Jouw e-mail",
        "token": "Jouw token",
        "errors": {
          "domain_not_found": "Domein kan niet worden gevonden"
        },
        "subtitle": "Log in met je account",
        "token_sent_to": {
          "dummy": "Er is geen token verzonden naar het demo account, de bruikbare token vind je terug in de instructies",
          "email": "Jouw token is verzonden per e-mail naar {{recipient}}, controleer de spam-folder als je de e-mail niet hebt ontvangen.",
          "sms": "Jouw token is verzonden per SMS {{recipient}}, ontvang je het sms-bericht niet? Je kan deze ook ontvangen op je e-mailadres.",
          "unknown": "Jouw token is verzonden per [unknown] naar {{recipient}}"
        },
        "token_hint": "6 cijferige token",
        "token_button_resend": "Stuur token opnieuw",
        "welcome": "Welkom {{name}}",
        "authentication_mode": {
          "qr": "QR-code",
          "token": "Token"
        },
        "authentication_mode_title": "Ga verder met",
        "title": "Welkom",
        "revalidate_token_sent": "Er is een token verstuurd ter verificatie van de sessie."
      }
    },
    "transport": {
      "title": "Vervoer",
      "save": "Opslaan",
      "intro": "Hoe ben je vandaag naar het werk gekomen?",
      "text_selected": "Je hebt aangegeven dat je vandaag met {{kind, lowercase}} bent gekomen.",
      "button_change": "Pas vervoer aan",
      "button_cancel": "Annuleren",
      "selected_not": "Nog geen vervoer aangegeven voor naar {{building}}",
      "selected": "Je bent vandaag naar {{building}} gekomen met: {{kind,lowercase}}",
      "button_home": "Terug naar beginpagina",
      "countdown": "Over {{seconds}} seconden wordt je teruggestuurd."
    },
    "ero": {
      "title": "BHV'er",
      "button_call": "Bel {{name}}",
      "call_description": "Ongeval?",
      "building_text": "{{present}} op {{building}}",
      "emergency_description": "Levensbedreigend ongeval?",
      "button_emergency": "Bel hulpdienst {{number}}"
    },
    "confidant": {
      "title": "Vertrouwenspersoon",
      "description": "Bel {{name}} als je aliquam varius viverra eros, euismod malesuada enim tempus nec. In eros justo, rutrum vel rutrum sed, consectetur nec lacus",
      "button_call": "Bel {{name}}",
      "building_text": "{{present}} op {{building}}",
      "call_description": "Hulp nodig?"
    },
    "team": {
      "title": "In welk team zit jij?",
      "description": "Om verder te gaan moeten we weten in welk team je zit, hiermee weten we wie je collega's zijn."
    },
    "invitation": {
      "overview": {
        "title": "Verstuurde uitnodiging",
        "description": "Deze boeking betreft {{amount}} personen. Je kan zien wie nog moet reageren op de uitnodiging, heeft geaccepteerd of afgewezen. ",
        "save": "Opslaan",
        "cancel": "Annuleren",
        "actions": {
          "revoke": "Uitnodiging terugtrekken",
          "accept_manually": "Wijzig collega's naar geaccepteerd",
          "reject_manually": "Wijzig collega's naar afgemeld",
          "hide": "Uitnodiging archiveren"
        },
        "alert": {
          "remove": {
            "title": "Uitnodiging verwijderen",
            "description": "Weet je zeker dat je de uitnodiging wilt verwijderen? De boekingen zullen voor alle genodigden worden verwijderd.",
            "confirm": "Ja, ik weet het zeker"
          },
          "hide": {
            "description": "Weet je zeker dat je de uitnodiging wilt archiveren? Hierna is het niet mogelijk de uitnodiging vanuit deze pagina in te zien.",
            "title": "Uitnodiging archiveren",
            "confirm": "Ja, ik weet het zeker"
          }
        }
      },
      "view": {
        "alerts": {
          "cancel": {
            "title": "Weet je het zeker?",
            "message_some": "Niet alle uitnodigingen zijn geaccepteerd, {{amount}} uitnodiging zullen automatisch worden afgewezen.",
            "message_all": "Alle uitnodiging zullen worden afgewezen."
          }
        }
      },
      "log": {
        "status_changed": "Status aangepast naar {{status}}",
        "title": "Activiteiten"
      }
    },
    "workdays": {
      "title": "Werkdagen",
      "introduction": "Geef hieronder je werkdagen/tijden op zodat $t(app_name) kan communiceren dat je een thuiswerkdag hebt indien je geen werkplek op kantoor hebt geboekt.\n\nBen je vrij of op vakantie? Zet dan out-of-office aan zo krijgen je collega's geen thuiswerkdagen te zien en wordt je niet ongewenst gestoord!",
      "vacation_mode": "Out-of-office"
    },
    "events": {
      "no_results": "Er zijn op dit moment geen evenementen beschikbaar.",
      "button_registration": "Aanmelden",
      "alert": {
        "title": "Je verlaat de app",
        "description": "De app zal de registratie pagina van het evenement openen in de browser. Weet je zeker dat je door wilt gaan?",
        "confirm": "Open in browser"
      }
    },
    "event": {
      "empty": "Evenement niet gevonden"
    },
    "qr_code": {
      "title": "Scan voor aanwezigheid",
      "not_available_yet": "De QR-code is nog niet beschikbaar.",
      "instructions": "Bekijk instructies"
    },
    "commute": {
      "commute": {
        "title": "Woon-werkverkeer"
      }
    },
    "credits": {
      "item": {
        "name": "{{timeslotKind}} credit",
        "unused": "Ongebruikte credits: {{amount}}",
        "status": {
          "unused": "Credit ongebruikt",
          "used": "Credit gebruikt op {{datetime}}"
        },
        "not_enough": "Je hebt niet genoeg credits om de boeking te voltooien. Koop meer credits om verder te gaan."
      },
      "buy": "Koop credits",
      "transactions": "Bekijk mijn transacties",
      "transaction": {
        "amount": "Aantal",
        "status_item": {
          "created": "Aangemaakt",
          "completed": "Afgerond",
          "pending": "In verwerking",
          "canceled": "Geannuleerd"
        },
        "status": "Status",
        "credits_amount": "Aantal credits",
        "price": "Prijs",
        "price_total": "Prijs totaal"
      }
    },
    "credits_buy": {
      "modal": {
        "description": "Je staat op het punt om '{{amount}}' credits aan te schaffen voor {{price}}. Druk op de knop '$t(page.credits_buy.modal.confirm)' om door te gaan.",
        "confirm": "Start betaling",
        "cancel": "Annuleren",
        "title": "Betaling",
        "change_amount": "Hoeveel keer wil je {{amount}} credits kopen?"
      },
      "payment": {
        "created": "Je wordt doorgestuurd naar een externe betaalpagina om je aankoop te voltooien.\nZodra de betaling is afgerond, keren we automatisch terug naar de app.\n\nHeb je deze pagina per ongeluk gesloten? Geen zorgen! Je kunt altijd opnieuw proberen via ondestaande knop.",
        "open_payment": "Open de betaalpagina",
        "failed": "Er is iets misgegaan tijdens het verwerken van je betaling.\nGeen zorgen. Je kunt het eenvoudig opnieuw proberen door op de knop hieronder te drukken.",
        "retry_payment": "Probeer opnieuw",
        "completed": "Je betaling is succesvol verwerkt.\nJe kunt nu verdergaan door op de knop hieronder te drukken.",
        "button_completed": "Ga naar home",
        "pending": "We hebben je betaling ontvangen, maar deze wordt nog verwerkt.\nZodra de betaling is bevestigd, kun je verdergaan.\n\nJe kunt op de knop hieronder drukken om terug te gaan naar de homepagina.",
        "button_goback": "Ga terug"
      }
    }
  },
  "error": {
    "retry_button": "Probeer opnieuw",
    "retry_text": "Het is niet gelukt om de gegevens op te halen.",
    "error_login": {
      "text": "Het is ons niet gelukt je sessie te controleren. Druk op onderstaande knop het opnieuw te proberen.",
      "button_logout": "Log nu uit"
    },
    "global": {
      "title": "Oeps! Er is iets misgegaan",
      "text": "Er is een probleem opgetreden met de app en kan niet doorgaan. Onze excuses voor het eventuele ongemak dat dit heeft veroorzaakt! Druk op de onderstaande knop om de app opnieuw te starten. Neem contact met ons op als dit probleem zich blijft voordoen.",
      "button": "Herlaad"
    }
  },
  "modal": {
    "logout": {
      "title": "Weet je zeker dat je uit wilt loggen?",
      "button": "Log nu uit"
    }
  },
  "form": {
    "select": {
      "placeholder": "Maak een keuze",
      "search_placeholder": "Zoeken..."
    },
    "fields": {
      "license_plate": {
        "title": "Kenteken van jouw voertuig",
        "description": "Indien het opgeven van je kenteken word vereist bij het boeken van een parkeerplek word deze instelling automatisch ingevuld tijdens het boeken"
      },
      "access_card_id": {
        "title": "Toegangskaartnummer",
        "description": "Jouw toegangskaartnummer wordt gebruikt om je automatisch in te checken bij een Speedgate"
      },
      "department": {
        "title": "Afdeling"
      },
      "team": {
        "title": "Team"
      },
      "jobtitle": {
        "title": "Functietitel"
      },
      "language": {
        "title": "Taal",
        "description": "De app zal herstarten bij het wijzigen van de taal"
      },
      "phonenumber": {
        "title": "Mobiel telefoonnummer"
      },
      "landline_phonenumber": {
        "title": "Vast telefoonnummer"
      },
      "lunch_option": {
        "description": "Met bovenstaande keuzelijst is het mogelijk een standaard lunch optie te selecteren voor toekomstige boekingen",
        "title": "Standaard lunch optie",
        "not_available": "Er zijn geen lunch opties beschikbaar"
      },
      "name": {
        "title": "Naam"
      },
      "transport_kind": {
        "title": "Standaard vervoerskeuze",
        "description": "Met bovenstaande keuzelijst is het mogelijk een standaard vervoerskeuze te selecteren voor toekomstige boekingen"
      },
      "response_employee": {
        "title": "Bedrijfshulpverlener"
      },
      "email": {
        "title": "E-mailadres"
      },
      "full_name": {
        "title": "Voor + achternaam"
      },
      "show_favourite": {
        "title": "Wie mag jou als favoriet toevoegen",
        "description": "Als een collega je toevoegd als favoriet kan hij/zij je boekingen zien op het homescherm, tijdens het boeken en in je profielpagina",
        "values": {
          "no": "Niemand",
          "team": "Mijn team",
          "company": "Iedereen"
        }
      },
      "show_phonenumber": {
        "title": "Wie mag jouw telefoonnummer zien",
        "values": {
          "no": "Niemand",
          "team": "Mijn team",
          "company": "Iedereen"
        }
      },
      "show_calendar": {
        "title": "Wie mag jouw boekingen zien",
        "description": "Collega's kunnen je boekingen ook bekijken via je profiel pagina afhankelijk van deze instelling",
        "values": {
          "no": "Niemand (behalve favorieten)",
          "team": "Mijn team (en favorieten)",
          "company": "Iedereen"
        }
      },
      "visible_for_employees": {
        "title": "Ben ik zichtbaar voor andere collega's?",
        "description": "Sta collega's toe mij te vinden in de app"
      },
      "scan_type": {
        "qrcode": "QR-code",
        "button": "Knop"
      },
      "address": {
        "title": "Postcode",
        "description": "Vul alleen de eerste 4 cijfers in van je postcode"
      }
    },
    "warnings": {
      "empty": "Vul een {{field, lowercase}} in",
      "invalid": "Vul een geldig {{field, lowercase}} in"
    },
    "timeslot_time_select": {
      "information": "Het '$t(form.timeslot_time_select.until)' veld is niet verplicht en zal elke dag een random tijd 'random' maken.",
      "from": "Tijd",
      "until": "Tot"
    }
  },
  "notification": {
    "booking_saved": "Je boeking is geplaatst",
    "scan_success": {
      "scan_in": "Met succes ingecheckt",
      "scan_out": "Met succes uitgecheckt",
      "automatic": "Automatisch ingechecked"
    },
    "booking_saved_other": "Je boekingen zijn geplaatst"
  },
  "app_name": "My office days",
  "app_domain": "@myofficedays",
  "basic": {
    "scan_in": "Inchecken",
    "scan_out": "Uitchecken",
    "next_step": "Volgende",
    "loading": "Bezig met laden..",
    "ok": "Oké",
    "place_available": "Plaats beschikbaar",
    "place_available_other": "Plaatsen beschikbaar",
    "present_yes": "Aanwezig",
    "present_no": "Niet aanwezig",
    "present_no_note": "Het is mogelijk dat {{name}} aanwezig is, maar zich niet heeft ingecheckt",
    "brightness_info": "Zet de helderheid van je scherm op maximaal voor het scannen van de QR-code",
    "transport": {
      "kind": {
        "car": "Auto",
        "public_transport": "Openbaar vervoer",
        "other": "Anders",
        "car_sentence": "De auto",
        "public_transport_sentence": "Het openbaar verboer",
        "other_sentence": "Overig vervoer",
        "bike": "Fiets",
        "bike_sentence": "De fiets",
        "car_electric": "Elektrische auto",
        "scooter": "Scooter",
        "scooter_sentence": "De scooter",
        "car_electric_sentence": "De elektrische auto",
        "motorcycle": "Motorfiets",
        "motorcycle_electric": "Elektrische motorfiets",
        "motorcycle_electric_sentence": "De elektrische motorfiets",
        "motorcycle_sentence": "De motorfiets"
      }
    },
    "yes": "Ja",
    "no": "Nee",
    "available_for": {
      "everyone": "Iedereen",
      "restricted": "Beperkt (Teams)",
      "restricted_employees": "Beperkt (Medewerkers)"
    },
    "cancel": "Annuleren",
    "accept": "Accepteren",
    "and": "en",
    "reject": "Afwijzen",
    "load_more": "Laad meer",
    "yourself": "Jezelf",
    "organizer": "Organisator",
    "you": "Jij",
    "save": "Opslaan",
    "all": "alle",
    "searching": "Bezig met zoeken..",
    "day": "Dag",
    "day_other": "Dagen",
    "archive": "Bekijk archief",
    "activity": "Activiteit",
    "more": "Meer",
    "continue": "Doorgaan",
    "choose_image": "Kies een afbeelding"
  },
  "permission": {
    "camera": {
      "request_permission": "Cameratoestemming aanvragen",
      "request_button": "Cameratoegang toestaan",
      "no_permission": "We hebben geen toestemming om gebruik te maken van de camera. De camera is nodig om de QR-code te scannen om je aanwezigheid te registreren.",
      "settings_button": "Open instellingen"
    }
  },
  "date": {
    "week": "Week",
    "days": {}
  },
  "updates": {
    "start": {
      "title": "De nieuwe update is binnen",
      "subtitle": "De app is weer helemaal up-to-date en zit weer vol met nieuwe functies!"
    },
    "1_2_0": {
      "profile_lunch": {
        "title": "Standaard lunch optie",
        "subtitle": "In je profiel is het nu mogelijk om jouw standaard lunch optie te selecteren. Bij het boeken van een lunch is het daardoor niet meer nodig om het steeds weer te selecteren."
      },
      "book_multiple": {
        "title": "Boek meer",
        "subtitle": "Je kan nu meerdere boeking voor meerdere dagen tegelijk plaatsen"
      }
    },
    "basic": {
      "next": "Volgende",
      "skip": "Overslaan"
    },
    "1_3_0": {
      "look_and_feel": {
        "title": "Vernieuwe stijl",
        "subtitle": "We hebben de stijl van de app vernieuwd! Deze vernieuwing zorgt voor een rustigere en beter ervaring."
      },
      "book_transport": {
        "title": "Vervoerkeuze",
        "subtitle": "In de app is het nu mogelijk om aan te geven hoe je naar kantoor bent gekomen."
      },
      "security": {
        "title": "Verbeterde beveiliging",
        "subtitle": "We hebben de beveiliging van de app verbeterd, sorry dat je hierdoor helaas opnieuw moest inloggen."
      },
      "coworkers": {
        "title": "Collega's inzien uitgebreid",
        "subtitle": "Het toevoegen van collega's en het uitnodigen van collega's is verbeterd! "
      }
    },
    "2_2_17": {
      "workdays": {
        "title": "Jouw werkdagen",
        "subtitle": "Laat je collega's weten of je vandaag werkt! Ga naar 'Meer' > 'Mijn werkdagen' om je werkdagen in te stellen."
      }
    }
  },
  "update": {
    "title": "Er is een update beschikbaar",
    "message": "Druk op onderstaande knop op de app een update te geven. Updaten duurt vaak maar een paar seconden.",
    "button_ok": "Updaten",
    "failed": {
      "title": "Updaten is mislukt",
      "message": "Het is helaas niet gelukt om de app een update te geven."
    },
    "up_to_date": {
      "title": "App is up-to-date",
      "message": "Je hebt al de nieuwste versie van de app geïnstalleerd"
    },
    "check": "Controleer op updates"
  },
  "company": "Bedrijf",
  "team": "Team",
  "department": "Afdeling",
  "jobtitle": "Functie",
  "email": "E-mailaddress",
  "phonenumber": "Telefoonnummer",
  "filters": {
    "company_guid": "Bedrijf",
    "department_guid": "Afdeling",
    "jobtitle_guid": "Functie",
    "team_guid": "Team"
  },
  "test_warnings": {
    "domain_with_t": "Je gebruikt momenteel de test-applicatie van $t(app_name).\n\nIndien er een test-omgeving beschikbaar is zal het hier ondersteund worden. Productie omgevingen kunnen niet worden gebruikt in deze omgeving\n\nHet plaatsen van bijvoorbeeld boekingen zal geen werkplek reserveren op kantoor!",
    "warning": "!Let op!",
    "test_flight": "Test flight!"
  },
  "calendar": {
    "week": "Week {{week}} - {{year}}",
    "show_week_calendar": "Toon weekkalender",
    "show_month_calendar": "Toon maandkalender"
  },
  "calendar_capacity": {
    "workplaces_available": "Beschikbare werkplekken"
  },
  "unit": {
    "minute": "Minuut",
    "minute_other": "Minuten",
    "day": "Dag",
    "day_other": "Dagen",
    "week": "Week",
    "week_other": "Weken",
    "month": "Maand",
    "month_other": "Maanden",
    "year": "Jaar",
    "year_other": "Jaren",
    "hour": "Uur",
    "hour_other": "Uren"
  },
  "lunch_scanner": {
    "index": {
      "instructions": "Open de QR-code van jouw boeking.",
      "scan_hint": "Houd de QR-code voor de camera. De boekingsgegevens verschijnen hier ter bevestiging.",
      "back": "Terug",
      "switch_camera": "Wissel camera",
      "settings": "Instellingen",
      "camera_hint": "Houd de QR-code van je boeking voor de camera.",
      "buttons": {
        "checkin": "Checkin",
        "cancel": "Annuleren"
      },
      "camera": "Camera",
      "status": {
        "VALID": {
          "intro": "Je bent met succes ingechecked",
          "afternoon": "Fijne middag, {{name}}!",
          "morning": "Fijne dag, {{name}}!",
          "evening": "Fijne avond, {{name}}!",
          "night": "Fijne nacht, {{name}}!"
        },
        "WRONG_DAY": "De QR-code is niet voor vandaag",
        "ALREADY_CHECKED_IN": "Je bent al ingecheckt",
        "INVALID": "De QR-code is niet geldig"
      }
    },
    "sleeping": {
      "text": "Tablet staat in energie bespaarmodus",
      "button": "Haal uit bespaarmodus"
    }
  },
  "parking_status": {
    "label": "Parkeergarage",
    "full": "Vol",
    "free": "Vrij"
  },
  "notifications": {
    "request_text": "We vragen je straks om toestemming om meldingen te sturen. Je ontvangt alleen relevante meldingen over je boekingen."
  },
  "ui": {
    "loading": "Bezig met laden",
    "powered_by": "Kantoorplanning mogelijk gemaakt door",
    "privacy_statement": "Privacyverklaring",
    "sleep": "Slaapstand",
    "country_netherlands": "Nederland",
    "onboarding_web_unavailable": "De introductie is niet beschikbaar op het web.",
    "filter": "Filter",
    "unknown": "Onbekend"
  },
  "debug_ui": {
    "title": "Diagnostiek",
    "pages": "Pagina’s",
    "interface_tests": "Interfacetests",
    "cache": "Cache",
    "cache_updated_at": "Cachetijdstempels",
    "redux": "Redux",
    "push_notifications": "Pushmeldingen",
    "update_errors": "Updatefouten",
    "account_errors": "Accountfouten",
    "transport_select": "Vervoer selecteren",
    "icons": "Pictogrammen",
    "video": "Video",
    "write_console": "Naar console schrijven",
    "clear": "Wissen",
    "refresh_cache_timestamp": "Cachetijdstempels vernieuwen",
    "write_data": "Gegevensstatus naar console schrijven",
    "write_cart": "Boekingsstatus naar console schrijven",
    "write_design": "Ontwerpstatus naar console schrijven",
    "get_token": "Token ophalen",
    "check_update_errors": "Controleren op updatefouten",
    "check_account_errors": "Controleren op accountfouten",
    "cache_size": "Cachegrootte berekenen ({{size}})",
    "no_update": "Geen update beschikbaar",
    "error": "Fout: {{message}}",
    "debug": "Diagnostiek: {{message}}",
    "account": "Account: {{domain}} - {{name}}",
    "icons_title": "Pictogramdiagnostiek"
  }
}
